<template>
  <div :class="classHash">
    <img
      alt="Loading…"
      class="spinner__image"
      :class="{ 'spinner__image--paused': paused }"
      :src="imageSource"
    />
  </div>
</template>

<script>
export default {
  name: "Spinner",
  props: {
    classes: {
      default: "",
      type: String
    },
    inline: {
      default: false,
      type: Boolean
    },
    size: {
      default: "",
      type: String
    },
    theme: {
      default: "grey",
      type: String
    },
    paused: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      origin: "https://jiffyimg.imgix.net/",
      pathname: {
        dark: "gen/spinner.png",
        grey: "gen/spinner-grey.png",
        white: "gen/spinner-white.png"
      }
    };
  },
  computed: {
    classHash() {
      const classHash = {
        spinner: true,
        "spinner--inline": !!this.inline
      };

      if (this.size) {
        classHash[`spinner--size-${this.size}`] = true;
      }

      if (this.classes) {
        this.classes.split(" ").forEach(className => {
          classHash[className] = !0;
        });
      }

      return classHash;
    },
    imageSource() {
      return this.origin + this.pathname[this.theme];
    }
  }
};
</script>
